import type { Resource } from '../../';
export const general_errors_closeStacktrace: Resource = {"default":"Close stacktrace"};
